import PropTypes from 'prop-types';
import React from 'react';
import warning from 'warning';

interface TextFormattedReplaceProps {
  children: string;
  replaces: Record<string, () => JSX.Element>;
}

const TextFormattedReplace: React.FC<TextFormattedReplaceProps> = ({ children, replaces }) => {
  const parts = children.split('##');
  return (
    <>
      {parts.map((part, idx) => {
        if (idx % 2 === 0) {
          return <React.Fragment key={idx.toString()}>{part}</React.Fragment>;
        }

        warning(typeof replaces[part] === 'function', `TextFormattedReplace: Replacer ${part} is not a function.`);

        return replaces[part] ? <React.Fragment key={idx.toString()}>{replaces[part]()}</React.Fragment> : null;
      })}
    </>
  );
};

TextFormattedReplace.propTypes = {
  children: PropTypes.string.isRequired,
  /**
   * Shape of replace renderers, `{[replKey: string]: () => JSX.Element}`.
   */
  replaces: PropTypes.shape({}).isRequired,
};

export default TextFormattedReplace;
